import * as Types from '../types/SubscriptionPackage';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    statusAction: {
        isUpdateDiscount: false,
        updateDiscountSuccess: false
    },
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.SUBSCRIPTION_PACKAGE_LIST_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_PACKAGE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: action.subscriptionPackages,
            };
        case Types.SUBSCRIPTION_PACKAGE_MASTER_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_PACKAGE_MASTER_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.SUBSCRIPTION_PACKAGE_GET_TEM_ACTION:
            return {...state, isFetching: true};
        case Types.SUBSCRIPTION_PACKAGE_GET_TEM_SUCCESS:
            return {...state, isFetching: false, item: action.item};
        case Types.SUBSCRIPTION_PACKAGE_UPDATE_ACTION:
            return {
                ...state, isFetching: true,
                statusAction: {
                    ...initialState.statusAction,
                    isUpdateDiscount: true,
                    updateDiscountSuccess: false,
                }
            };
        case Types.SUBSCRIPTION_PACKAGE_UPDATE_SUCCESS:
            return {
                ...state, isFetching: false,
                statusAction: {
                    ...initialState.statusAction,
                    isUpdateDiscount: false,
                    updateDiscountSuccess: true,
                }
            };
        case Types.SUBSCRIPTION_PACKAGE_FAILED:
            return {...state, isFetching: false, errors: action.errors, statusAction: initialState.statusAction};
        case Types.SUBSCRIPTION_PACKAGE_INIT:
            return initialState;
        default:
            return state;
    }
}
